<template>
    
</template>

<script>
    export default {
        name: "draggable"
    }
</script>

<style scoped>

</style>